import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  generateQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/quiz-generator`,
  },
  generateSlide: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/generate-slide`,
  },
  requestMoreQuiz: {
    method: 'POST',
    url: `${configs.baseUrl}/api/openai/request-more-quiz`,
  },
  getExamples: {
    method: 'GET',
    url: `${configs.baseUrl}/api/openai/get-examples`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateQuiz = async (params) => {
  const res = await resource.generateQuiz(params)
  return res.body
}

const generateSlide = (params) => {
  resource.generateSlide(params)
}

const requestMoreQuiz = async (params) => {
  const res = await resource.requestMoreQuiz(params)
  return res.body
}

const getExamples = async () => {
  const res = await resource.getExamples()
  return res.body
}

export default {
  initResource,
  generateQuiz,
  generateSlide,
  requestMoreQuiz,
  getExamples,
}
